import { useState, useCallback } from 'react';
import { ISiteVisit, ISiteVisitPosition } from '../../types';
import { sanitizeSiteVisitData } from '../../utils';

export const useSiteVisitState = (initialSiteVisit?: ISiteVisit | null) => {
  const [siteVisit, setSiteVisit] = useState<ISiteVisit | null>(initialSiteVisit || null);
  const [position, setPosition] = useState<ISiteVisitPosition>({
    categoryIndex: 0,
    questionIndex: 0,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const initializeSiteVisit = useCallback(
    (rawSiteVisit: Record<string, unknown>, preservePosition = false) => {
      try {
        const sanitizedSiteVisit = sanitizeSiteVisitData(rawSiteVisit);
        setSiteVisit(sanitizedSiteVisit);
        if (!preservePosition) {
          setPosition({ categoryIndex: 0, questionIndex: 0 });
        }
        setError(null);
      } catch (error) {
        const errorMessage =
          error instanceof Error ? error.message : 'Failed to load site visit data';
        console.error('SiteVisit initialization failed:', error);
        setError(errorMessage);
      }
    },
    []
  );

  const updateSiteVisit = useCallback((newSiteVisit: ISiteVisit) => {
    setSiteVisit(newSiteVisit);
    setPosition({ categoryIndex: 0, questionIndex: 0 });
  }, []);

  return {
    siteVisit,
    setSiteVisit,
    position,
    setPosition,
    isLoading,
    setIsLoading,
    error,
    setError,
    initializeSiteVisit,
    updateSiteVisit,
  };
};
